// Base URL of the JSON API, shared by every fetch wrapper.
//
// The SPA's HTML shell is always served by Symfony: in dev the :8003 app renders
// templates/app/index.html.twig and only the modules come from Vite, in prod the
// bundle is served by the same app. So a relative "/api" is same-origin in every
// case -- and it is the only value that works on a phone that opens the dev server
// through the LAN IP, where a hardcoded "http://localhost:8003/api" resolves to the
// phone itself and every call fails.
//
// Set VITE_API_URL to point the front end at another host (a remote API, a tunnel).
export const API_BASE_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/+$/, '') || '/api';
